import { Box, Skeleton } from "@mui/material";

const ForYouSongListSkeleton = ({ count = 6 }) => {
  const placeholders = Array.from({ length: count });

  return (
    <Box
      sx={{
        display: "grid",
        gap: 3,
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        },
        pX: { xs: 0, sm: 2 },
        pY: 2,
      }}
    >
      {placeholders.map((_, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "background.default",
            borderRadius: 2,
            overflow: "hidden",
            px: 1,
            py: 1,
            boxShadow: 1,
          }}
        >
          <Skeleton
            variant="rounded"
            width={60}
            height={60}
            sx={{ flexShrink: 0, borderRadius: 1 }}
          />

          <Box sx={{ flexGrow: 1, px: 2, overflow: "hidden" }}>
            <Skeleton variant="text" width="80%" height={20} />
            <Skeleton variant="text" width="60%" height={18} />
            <Box sx={{ display: "flex", mt: 0, gap: 1 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </Box>

          <Box
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "flex",
              },
              gap: 1,
            }}
          >
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ForYouSongListSkeleton;
